/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24.05 0c-13.234 0-24 10.766-24 24s10.766 24 24 24 24-10.766 24-24-10.766-24-24-24zm0 42.891C13.627 42.891 5.159 34.423 5.159 24S13.627 5.109 24.05 5.109 42.941 13.577 42.941 24 34.473 42.891 24.05 42.891z"/><path pid="1" d="M21.191 31.314v5.544h5.652v-5.544zm5.652-13.248v-6.912h-5.652v6.912l1.512 9.072h2.556z" fill-rule="nonzero"/>'
}
